import { Modal } from 'antd';

import Button from './Button';

const ConfirmationModal = ({
  isOpen,
  text,
  width = 340,
  loading = false,
  onSubmit,
  onCancel,
  submitText = 'Delete',
  submitButtonProps = {},
  cancelButtonProps = {},
  cancelText = 'Cancel',
  titleStyle = {},
  centered = false,
}) => {
  return (
    <Modal
      open={isOpen}
      width={width}
      footer={null}
      onCancel={onCancel}
      closeIcon={null}
      centered={centered}
      destroyOnHidden
    >
      <p className='mb-16 fw-500' style={titleStyle}>
        {text}
      </p>
      <div className='flex' style={{ gap: '12px' }}>
        <Button
          type='primary'
          className='btn-s'
          {...submitButtonProps}
          onClick={onSubmit}
          loading={loading}
        >
          {submitText}
        </Button>
        <Button
          type='default'
          className='btn-s'
          color='danger'
          variant='outlined'
          {...cancelButtonProps}
          onClick={onCancel}
        >
          {cancelText}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
